var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2824 2.73913C22.3791 -0.913049 27.6209 -0.913038 29.7176 2.73913L49.2621 36.7826C51.3588 40.4348 48.7379 45 44.5444 45H5.45556C1.26212 45 -1.35877 40.4348 0.737946 36.7826L20.2824 2.73913ZM24.9999 10.5809C26.2892 10.5809 27.3345 11.632 27.3345 12.9287V23.8852C27.3345 25.1819 26.2892 26.2331 24.9999 26.2331C23.7105 26.2331 22.6652 25.1819 22.6652 23.8852L22.6652 12.9287C22.6652 11.632 23.7105 10.5809 24.9999 10.5809ZM24.9999 38.7548C26.719 38.7548 28.1127 37.3533 28.1127 35.6244C28.1127 33.8955 26.719 32.4939 24.9999 32.4939C23.2807 32.4939 21.887 33.8955 21.887 35.6244C21.887 37.3533 23.2807 38.7548 24.9999 38.7548Z",
    fill: "url(#paint0_linear_17675_144015)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17675_144015",
    x1: -0.324596,
    y1: 0.234526,
    x2: 50.5724,
    y2: 44.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF9F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D75903"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.2263e33712ef969087a3b112da4fb0e2.svg";
export { ForwardRef as ReactComponent };